module.exports = __webpack_public_path__ + "static/media/inprocess.d8f46171.svg";